import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function ArticleContent({ markdown }: { markdown: string }) {
  return (
    <div className="article-content">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
}
